"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import { useTheme as c } from "../../hooks.js";
import { useIsInverseVariant as m } from "../../theme-variant-context.js";
import { vars as t } from "../../skins/skin-contract.css-mistica.js";
const a = (_param)=>{
    var { color: n, size: e = 24 } = _param, r = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const i = m(), l = n !== null && n !== void 0 ? n : i ? t.colors.inverse : t.colors.neutralHigh, { skinName: s } = c();
    return s.match(/^o2-new/i) ? /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ o("path", {
            fill: l,
            d: "m11.204 2.5-7.3 7.664L14.7 21.5l7.3-7.664zm7.615 10.188-5.141-1.45-1.381-5.398zM10.93 4.969l1.763 6.892a.57.57 0 0 0 .39.411l6.565 1.85-4.948 5.196-8.718-9.154zm.274 14.28c0 .425-.33.772-.736.772H4.945c-.405 0-.735-.347-.735-.772s.33-.772.735-.772h5.523c.406 0 .736.346.736.772m-8.469-2.32h4.048c.406 0 .735-.347.735-.773 0-.425-.33-.772-.735-.772H2.735c-.405 0-.735.347-.735.772s.33.772.735.772"
        })
    })) : /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ o("path", {
            fill: l,
            d: "m11.204 2.5-7.3 7.664L14.7 21.5l7.3-7.664zm7.615 10.188-5.141-1.45-1.381-5.398zM10.93 4.969l1.763 6.892a.57.57 0 0 0 .39.411l6.565 1.85-4.948 5.196-8.718-9.154zm.274 14.28c0 .425-.33.772-.736.772H4.945c-.405 0-.735-.347-.735-.772s.33-.772.735-.772h5.523c.406 0 .736.346.736.772m-8.469-2.32h4.048c.406 0 .735-.347.735-.773 0-.425-.33-.772-.735-.772H2.735c-.405 0-.735.347-.735.772s.33.772.735.772"
        })
    }));
}, u = a;
export { u as default };
